import { render, staticRenderFns } from "./PostsListing.vue?vue&type=template&id=28733862"
import script from "./PostsListing.vue?vue&type=script&lang=js"
export * from "./PostsListing.vue?vue&type=script&lang=js"
import style0 from "./PostsListing.vue?vue&type=style&index=0&id=28733862&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports